﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyMaintainHeight", [
    "$timeout",
    "GlobalBreakpoints",
    "CssMediaWatcher",
    "$filter",
    "$rootScope",
    "DebugLogger",
    function ($timeout, GlobalBreakpoints, CssMediaWatcher, $filter, $rootScope, DebugLogger) {
      var debugGroups = false; // Add pretty colours! So you can identify groups visually

      function getGroups($element) {
        var $elements = getAllElements($element);

        var groups = $elements
          .map(function (index, element) {
            var $item = angular.element(element);
            return $item.attr("data-ty-maintain-height-group");
          })
          .toArray();

        groups = $filter("arrayUnique")(groups).sort(function (groupA, groupB) {
          var depthA = $elements.filter('[data-ty-maintain-height-group="' + groupA + '"]:first').parents().length;
          var depthB = $elements.filter('[data-ty-maintain-height-group="' + groupB + '"]:first').parents().length;
          return depthB - depthA;
        });

        return groups.map(function (group) {
          return $elements.filter('[data-ty-maintain-height-group="' + group + '"]');
        });
      }

      function updateGroupSize($elsInGroup) {
        if (!$elsInGroup.length) {
          return;
        }

        var maxHeight = Math.max.apply(
          null,
          $elsInGroup.map(function (index, element) {
            var IE_MAX_HEIGHT_GRANULARITY = 0.01;
            var boundingRect = element.getBoundingClientRect(); // supports fractional pixels, unlike angular.element(...).height()
            return (
              Math.ceil((boundingRect.bottom - boundingRect.top) / IE_MAX_HEIGHT_GRANULARITY) *
              IE_MAX_HEIGHT_GRANULARITY
            ); // round up to nearest 100th-pixel for IE11 height consistency
          })
        );

        var MAX_RGB_COMPONENT_VALUE = 255;
        var HEX_RADIX = 16;

        function getRandomRGBComponentAsHex() {
          return Math.round(Math.random() * MAX_RGB_COMPONENT_VALUE).toString(HEX_RADIX);
        }

        if (debugGroups) {
          var groupColour =
            "#" + getRandomRGBComponentAsHex() + getRandomRGBComponentAsHex() + getRandomRGBComponentAsHex();
          angular.element($elsInGroup).css("box-shadow", "0 0 0 3px " + groupColour + " inset");
        }

        angular.forEach($elsInGroup, function (element) {
          var boundingRect = element.getBoundingClientRect();
          var height = boundingRect.bottom - boundingRect.top;

          if (height !== maxHeight) {
            angular.element(element).css("height", maxHeight + "px");
          }
        });
      }

      function resetSizes($element) {
        getAllElements($element).css("height", "");

        if (debugGroups) {
          getAllElements($element).css("outline", "");
        }
      }

      function getAllElements($element) {
        return $element.find("[data-ty-maintain-height-group]");
      }

      function repaint($element, isMaintainHeightsActive) {
        resetSizes($element);

        if (!isMaintainHeightsActive) {
          return;
        }

        var groups = getGroups($element);

        if (debugGroups) {
          DebugLogger.log("tyMaintainHeight.repaint about to updateGroupSize for ", groups.length, " groups");
        }

        angular.forEach(groups, updateGroupSize);
      }

      return {
        scope: true,
        compile: function () {
          var cssMediaWatcher;

          return {
            pre: function ($scope, $element, $attrs) {
              var maintainHeightsBreakpoints = GlobalBreakpoints.parseCompoundExpression(
                $attrs.tyMaintainHeightBreakpoints || "sm+"
              );

              cssMediaWatcher = CssMediaWatcher({
                $el: angular.element(".ty-global-breakpoint-sensor"),
                pseudoEl: "before",
                mediaProperty: "viewportWidth",
                mediaRegexes: {
                  maintainHeightsActive: "^(" + maintainHeightsBreakpoints.join("|") + ")$",
                },
              });

              // Ensure other directives can demand a refresh
              $rootScope.$on(
                "force-maintain-height",
                function (event, tyMaintainHeightId, didForceMaintainHeightCallback) {
                  if (tyMaintainHeightId === $attrs.tyMaintainHeightId) {
                    $timeout(function () {
                      repaint($element, cssMediaWatcher.getCurrentMedia().viewportWidth.is.maintainHeightsActive);
                      if (typeof didForceMaintainHeightCallback === "function") {
                        didForceMaintainHeightCallback();
                      }
                    });
                  }
                }
              );
            },
            post: function ($scope, $element, $attrs) {
              var maintainHeightOn = ($attrs.tyMaintainHeightOn && $attrs.tyMaintainHeightOn.split(" ")) || [];
              if (maintainHeightOn.indexOf("breakpoint") !== -1) {
                cssMediaWatcher.on("didChange", function () {
                  $timeout(function () {
                    repaint($element, cssMediaWatcher.getCurrentMedia().viewportWidth.is.maintainHeightsActive);
                  });
                });
              }

              if (maintainHeightOn.indexOf("resize") !== -1) {
                angular.element(window).on("resize", function () {
                  $timeout(function () {
                    repaint($element, cssMediaWatcher.getCurrentMedia().viewportWidth.is.maintainHeightsActive);
                  });
                });
              }

              repaint($element);
            },
          };
        },
      };
    },
  ]);
})(window.angular);
